
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SeAvatarModule, SE_AVATAR_MODULE_BUNDLE } from '../avatar/avatar.module'
import { SeIconModule, SE_ICON_MODULE_BUNDLE } from '../icon/icon.module'

import { SportIconService } from './sport-icon.service'
import { SeTeamAvatarComponent } from './team-avatar.component'

@NgModule({
  declarations: [
    SeTeamAvatarComponent,
  ],
  providers: [
    SportIconService,
  ],
  imports: [
	CommonModule, 
    SeAvatarModule,
    SeIconModule
  ],
  exports: [
    SeTeamAvatarComponent,
  ]
})
export class SeTeamAvatarModule { }

export const SE_TEAM_AVATAR_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.teamAvatar`

